module.exports = __webpack_public_path__ + "static/media/cropped-sphs.a513f33f.jpeg";